import { http } from '@/core/helpers/axiosHelper';
import { Batch } from '../batches/batch.interface';
import { Employment } from './employment.interface';
export interface EmploymentServiceInterface {
   createEmployment(employment: any): Promise<any>;
}

export class EmploymentService implements EmploymentServiceInterface {
   async createEmployment(employment: Employment): Promise<Employment> {
      return await http.post(`/employment`, employment).then((response) => response.data);
   }

   async batchCreateEmployments(employments: Array<Employment>): Promise<Batch> {
      const response = await http.post<Batch>(`/employment-batch`, { employments });
      return response.data;
   }
}
